import {isPlainObject} from 'rlink-type-utils';
/**
 * Returns the values iterator for the given object.
 *
 * @param  {IterableCollection} obj
 * @return {Iterator}
 */
export default function values (obj) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot iterate non-iterable object: ${obj}`);
  }
  if ( typeof obj.values === 'function') {
    return obj.values();
  } else if (isPlainObject(obj)){
    return Object.values(obj);
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/values.js